// extracted by mini-css-extract-plugin
export default {"noData":"Tabela_noData__jiXII"};